module.exports = __webpack_public_path__ + "static/media/6.4fd45933.png";